/* tslint:disable */

/**
 * Standard of price gas:
 *   * TTF_MA : TTF MA
 *   * PEG_MA : PEG MA
 */
type StandardGas =
  'TTF_MA' |
  'PEG_MA';
namespace StandardGas {
  export const TTF_MA: StandardGas = 'TTF_MA';
  export const PEG_MA: StandardGas = 'PEG_MA';
  export function values(): StandardGas[] {
    return [
      TTF_MA,
      PEG_MA
    ];
  }
}

export { StandardGas }